import React, { useEffect, useState } from "react";

// Use height for a fixed gap, or targetSelector to reserve space for a fixed bar.
const Spacer = ({ height = 24, targetSelector, gap = 0, className = "" }) => {
  const [targetHeight, setTargetHeight] = useState(null);

  useEffect(() => {
    if (!targetSelector) {
      setTargetHeight(null);
      return undefined;
    }

    const target = document.querySelector(targetSelector);
    if (!target) { setTargetHeight(0); return undefined; }

    const measure = () => setTargetHeight(target.getBoundingClientRect().height);
    measure();
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    observer?.observe(target);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [targetSelector]);

  return <div aria-hidden="true" className={className}
    style={{ height: targetHeight === null ? height : targetHeight + gap, flexShrink: 0 }} />;
};

export default Spacer;
